<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  infoDetailsMethods,
  actionsMethods,
  deviceComputed,
  deviceEventCurrentMethods,
} from '@state/helpers'

import toggle from '@utils/design/toggle-info'

export default {
  components: {
    VuePerfectScrollbar,
  },

  props: {
    deviceEventCurrent: {
      type: Object,
      default: () => {},
    },
  },

  data: function() {
    return {
      search: '',
      settings: {
        maxScrollbarLength: 60,
      },
    }
  },

  computed: {
    ...deviceComputed,

    filteredDevices: function() {
      return this.cachedDevices.filter((device) => {
        if (this.search.length > 0) {
          return device.name.toLowerCase().includes(this.search.toLowerCase())
        } else {
          return this.cachedDevices
        }
      })
    },
  },

  methods: {
    ...infoDetailsMethods,
    ...actionsMethods,
    ...deviceEventCurrentMethods,

    setNavigateDetails: function(deviceName, deviceId) {
      this.$router.push({
        name: 'Device State History Detail',
        params: {
          deviceName: deviceName.toLowerCase().replace(/\s/g, ''),
          deviceId: deviceId,
        },
      })
    },
  },
}
</script>

<template>
  <b-card-body
    class=" card list-group card-body info-card  mb-0 pl-0 pr-0 pt-2 pb-2 clearfix"
  >
    <b-form-group class="filter">
      <label for="name" class="w-100 font-weight-bold text-uppercase text-muted"
        >Search by Device Name</label
      >
      <b-form-input
        v-model="search"
        class=" mb-2"
        placeholder="Device Name..."
        type="text"
      ></b-form-input>
    </b-form-group>
    <div>
      <VuePerfectScrollbar
        class="scroll-area "
        style="
    min-height: 80vh;"
        :settings="settings"
      >
        <div class="h-100">
          <button
            v-for="device in filteredDevices"
            :key="device.id"
            type="button"
            class="list-group-item list-group-item-action text-uppercase"
            @click="setNavigateDetails(device.name, device.id)"
          >
            {{ device.name }}

            <br />
          </button>
        </div>
        <!-- <span>
        <b-badge
          class="mr-2 text-black"
          :variant="device.planned == true ? 'success' : 'danger'"
        >
          Planned
        </b-badge>
        <b-badge
          class="mr-2  text-black"
          :variant="device.available == true ? 'success' : 'danger'"
          >Available
        </b-badge>
      </span> -->
      </VuePerfectScrollbar>
    </div>
  </b-card-body>
</template>

<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: 300px;
  width: 100%;
}
.card-body-side {
  border-radius: 0px !important;
}
.tab-content {
  border-radius: 0px !important;
}
</style>
